import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { ArrowUp, ArrowDown } from 'lucide-react';

const subscriptionGrowthData = [
  { name: 'Week 1', active: 5 },
  { name: 'Week 2', active: 7 },
  { name: 'Week 3', active: 10 },
  { name: 'Week 4', active: 15 },
  { name: 'Week 5', active: 18 },
  { name: 'Week 6', active: 22 },
];

const TrendsTab = () => {
  return (
    <div className="space-y-6">
      {/* Subscription Growth Chart */}
      <div className="bg-white rounded-lg p-6 shadow-md">
        <h3 className="text-lg font-semibold mb-2">Subscription Growth</h3>
        <p className="text-sm text-gray-500 mb-4">Number of active subscriptions over time</p>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={subscriptionGrowthData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip formatter={(value) => [`${value} subscriptions`, 'Active']} />
              <Line 
                type="monotone" 
                dataKey="active" 
                stroke="#10B981" 
                strokeWidth={2}
                dot={{ fill: '#10B981', strokeWidth: 2 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Price Changes and Usage Grid */}
      <div className="grid gap-6 md:grid-cols-2">
        {/* Price Change Alerts */}
        <div className="bg-white rounded-lg p-6 shadow-md">
          <h3 className="text-lg font-semibold mb-4">Price Change Alerts</h3>
          <div className="space-y-4">
            {[
              { name: "Spotify", change: 1, date: "Jul 1", direction: "up" },
              { name: "Dropbox", change: 2, date: "Aug 15", direction: "up" },
              { name: "GitHub", change: 5, date: "Jun 1", direction: "down" },
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-between">
                <div>
                  <p className="font-medium">{item.name}</p>
                  <p className="text-sm text-gray-500">Effective {item.date}</p>
                </div>
                <div className={`flex items-center ${
                  item.direction === 'up' ? 'text-red-500' : 'text-green-500'
                }`}>
                  {item.direction === 'up' 
                    ? <ArrowUp className="h-4 w-4 mr-1" /> 
                    : <ArrowDown className="h-4 w-4 mr-1" />
                  }
                  ${item.change}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Usage Optimization */}
        <div className="bg-white rounded-lg p-6 shadow-md">
          <h3 className="text-lg font-semibold mb-4">Usage Optimization</h3>
          <div className="space-y-4">
            {[
              { name: "Hulu", usage: "Low", recommendation: "Consider cancelling" },
              { name: "Zoom Pro", usage: "Medium", recommendation: "Downgrade plan" },
              { name: "iCloud", usage: "High", recommendation: "Upgrade storage" },
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-between">
                <div>
                  <p className="font-medium">{item.name}</p>
                  <p className="text-sm text-gray-500">Usage: {item.usage}</p>
                </div>
                <button 
                  className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded-full hover:bg-gray-200 transition-colors"
                  onClick={() => {/* Add action handler */}}
                >
                  {item.recommendation}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrendsTab; 